import { useEffect } from 'react';

const SCROLLING_CLASS = 'is-scrolling';
const HIDE_DELAY_MS = 900;

/**
 * Thin overlay scrollbars: show thumb only while the user is scrolling,
 * then fade away (Apple-like overlay chrome).
 */
export default function useAutoHideScrollbar() {
  useEffect(() => {
    const timers = new WeakMap();

    const markScrolling = (el) => {
      if (!(el instanceof Element)) return;
      el.classList.add(SCROLLING_CLASS);
      const prev = timers.get(el);
      if (prev) window.clearTimeout(prev);
      const next = window.setTimeout(() => {
        el.classList.remove(SCROLLING_CLASS);
        timers.delete(el);
      }, HIDE_DELAY_MS);
      timers.set(el, next);
    };

    const onScroll = (event) => {
      const target = event.target;
      if (target === document || target === document.documentElement || target === document.body) {
        markScrolling(document.documentElement);
        return;
      }
      if (target instanceof Element) {
        markScrolling(target);
      }
    };

    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    return () => {
      document.removeEventListener('scroll', onScroll, { capture: true });
    };
  }, []);
}
